import type { Client } from "features/container/types";
import { Text, Stack } from "prism-react";

import type { AppId } from "utils/clientAppId";

import { ClientAvatar } from "./ClientAvatar";

interface Props {
  clients: Client[];
  followedClient?: Client;
  onClientClick?: (client: Client) => void;
}

export const MoreClientsList: React.FC<Props> = ({
  clients,
  followedClient,
  onClientClick,
}) => {
  return (
    <Stack gap={3}>
      {clients.map((client) => {
        const isDimmed = Boolean(
          followedClient && client.clientId !== followedClient.clientId,
        );
        return (
          <ClientListItem
            key={client.clientId}
            client={client}
            dimmed={isDimmed}
            onClick={() => onClientClick?.(client)}
          />
        );
      })}
    </Stack>
  );
};

interface ItemProps {
  client: Client;
  dimmed?: boolean;
  onClick: () => void;
}

const ClientListItem: React.FC<ItemProps> = ({ client, dimmed, onClick }) => {
  return (
    <Stack gap={2} horizontal>
      <ClientAvatar
        appBackgroundColor="$neutral-bg-medium"
        appId={client.appId as AppId}
        color={client.color}
        dimmed={dimmed}
        name={client.name}
        onClick={onClick}
        src={client.avatarUrl || undefined}
        variant="column"
      />
      <Text color="neutral-fg-high">{client.name}</Text>
    </Stack>
  );
};
